var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "div",
            { staticClass: "font-32 font-weight-500 cor-00 m-t-16 m-b-26" },
            [_vm._v("基本信息")]
          ),
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "htmc",
                    expression: "'htmc'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("htmc"),
                  rules: _vm.getRules("htmc"),
                  name: "htmc",
                  label: "合同名称",
                  placeholder: "请输入合同名称",
                  "input-align": "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.htmc,
                            placeholder: "请选择合同名称",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.htmc, "htmc")
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.htmc,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "htmc", $$v)
                  },
                  expression: "formData.htmc",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "khmc",
                    expression: "'khmc'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("khmc"),
                  required: _vm.isRequired("khmc"),
                  rules: _vm.getRules("khmc"),
                  name: "khmc",
                  maxlength: "50",
                  autosize: "",
                  label: "客户名称",
                  placeholder: "请输入客户名称",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.khmc,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "khmc", $$v)
                  },
                  expression: "formData.khmc",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "htje",
                    expression: "'htje'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("htje"),
                  type: "number",
                  name: "htje",
                  rules: _vm.getRules("htje"),
                  required: _vm.isRequired("htje"),
                  maxlength: 10,
                  placeholder: "请输入合同金额",
                  label: "合同金额",
                  "input-align": "right",
                },
                on: {
                  change: function ($event) {
                    return _vm.formatToTwoDecimals(_vm.formData, "htje")
                  },
                },
                model: {
                  value: _vm.formData.htje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "htje", $$v)
                  },
                  expression: "formData.htje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "htje",
                    expression: "'htje'",
                  },
                ],
                attrs: { label: "", "input-align": "right", readonly: "" },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.htje && _vm.formData.htje != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.htje) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.htje && _vm.formData.htje != 0
                            ? _c("span", { staticClass: "p-l-20" }, [
                                _vm._v(" 大写："),
                              ])
                            : _vm._e(),
                          _vm.formData.htje && _vm.formData.htje != 0
                            ? _c("span", { staticClass: "cor-F64646" }, [
                                _vm._v(
                                  _vm._s(_vm.getChinese(_vm.formData.htje))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.htje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "htje", $$v)
                  },
                  expression: "formData.htje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ykpje",
                    expression: "'ykpje'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("ykpje"),
                  type: "number",
                  name: "ykpje",
                  rules: _vm.getRules("ykpje"),
                  required: _vm.isRequired("ykpje"),
                  maxlength: 10,
                  placeholder: "请输入已开票金额",
                  label: "已开票金额",
                  "input-align": "right",
                },
                on: {
                  change: function ($event) {
                    return _vm.formatToTwoDecimals(_vm.formData, "ykpje")
                  },
                },
                model: {
                  value: _vm.formData.ykpje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ykpje", $$v)
                  },
                  expression: "formData.ykpje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ykpje",
                    expression: "'ykpje'",
                  },
                ],
                attrs: { label: "", "input-align": "right", readonly: "" },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.ykpje && _vm.formData.ykpje != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.ykpje) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.ykpje && _vm.formData.ykpje != 0
                            ? _c("span", { staticClass: "p-l-20" }, [
                                _vm._v(" 大写："),
                              ])
                            : _vm._e(),
                          _vm.formData.ykpje && _vm.formData.ykpje != 0
                            ? _c("span", { staticClass: "cor-F64646" }, [
                                _vm._v(
                                  _vm._s(_vm.getChinese(_vm.formData.ykpje))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.ykpje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ykpje", $$v)
                  },
                  expression: "formData.ykpje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "kpje",
                    expression: "'kpje'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("kpje"),
                  type: "number",
                  name: "kpje",
                  rules: _vm.getRules("kpje"),
                  required: _vm.isRequired("kpje"),
                  maxlength: 10,
                  placeholder: "请输入开票金额",
                  label: "开票金额",
                  "input-align": "right",
                },
                on: {
                  change: function ($event) {
                    return _vm.formatToTwoDecimals(_vm.formData, "kpje")
                  },
                },
                model: {
                  value: _vm.formData.kpje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "kpje", $$v)
                  },
                  expression: "formData.kpje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "kpje",
                    expression: "'kpje'",
                  },
                ],
                attrs: { label: "", "input-align": "right", readonly: "" },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.kpje && _vm.formData.kpje != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.kpje) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.kpje && _vm.formData.kpje != 0
                            ? _c("span", { staticClass: "p-l-20" }, [
                                _vm._v(" 大写："),
                              ])
                            : _vm._e(),
                          _vm.formData.kpje && _vm.formData.kpje != 0
                            ? _c("span", { staticClass: "cor-F64646" }, [
                                _vm._v(
                                  _vm._s(_vm.getChinese(_vm.formData.kpje))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.kpje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "kpje", $$v)
                  },
                  expression: "formData.kpje",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "kplx",
                    expression: "'kplx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "kplx",
                  required: _vm.isRequired("kplx"),
                  rules: _vm.getRules("kplx"),
                  value: _vm.formData.kplx,
                  label: "开票类型",
                  placeholder: "请选择开票类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.kplx,
                            placeholder: "请选择开票类型",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.kplx, "kplx")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.kplx.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.kplx, "show", $$v)
                              },
                              expression: "kplx.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择开票类型",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.kplx.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("kplx")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.kplx)
                                },
                              },
                              model: {
                                value: _vm.kplx.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.kplx, "filterText", $$v)
                                },
                                expression: "kplx.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "kplx",
                              attrs: { columns: _vm.kplx.filteredData },
                              on: {
                                cancel: function ($event) {
                                  _vm.kplx.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "kprq",
                    expression: "'kprq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("kprq"),
                  name: "kprq",
                  label: "开票日期",
                  placeholder: "开票日期",
                  "input-align": "right",
                  rules: _vm.getRules("kprq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.kprq,
                            placeholder: "请选择开票日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.kprq, "kprq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "kprq",
                          attrs: {
                            "min-date": _vm.minDate,
                            "show-confirm": false,
                            title: "选择开票日期",
                          },
                          on: { confirm: _vm.kprqConfirm },
                          model: {
                            value: _vm.kprq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.kprq, "show", $$v)
                            },
                            expression: "kprq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.kprq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "kprq", $$v)
                  },
                  expression: "formData.kprq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fpkjdw",
                    expression: "'fpkjdw'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "fpkjdw",
                  required: _vm.isRequired("fpkjdw"),
                  value: _vm.formData.fpkjdw,
                  label: "开具单位",
                  rules: _vm.getRules("fpkjdw"),
                  placeholder: "请选择开具单位",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.fpkjdw,
                            placeholder: "请选择开具单位",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.fpkjdw, "fpkjdw")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.fpkjdw.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.fpkjdw, "show", $$v)
                              },
                              expression: "fpkjdw.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择开具单位",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.fpkjdw.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("fpkjdw", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.fpkjdw,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.fpkjdw.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.fpkjdw, "filterText", $$v)
                                },
                                expression: "fpkjdw.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "fpkjdw",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.fpkjdw.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.fpkjdw.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bz",
                    expression: "'bz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("bz"),
                  required: _vm.isRequired("bz"),
                  rules: _vm.getRules("bz"),
                  name: "bz",
                  type: "textarea",
                  maxlength: "100",
                  rows: "3",
                  autosize: "",
                  label: "说明",
                  "show-word-limit": "",
                  placeholder: "标记需要注意的事项",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.bz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bz", $$v)
                  },
                  expression: "formData.bz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fpbz",
                    expression: "'fpbz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("fpbz"),
                  required: _vm.isRequired("fpbz"),
                  rules: _vm.getRules("fpbz"),
                  name: "fpbz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "发票备注",
                  "show-word-limit": "",
                  placeholder: "这里填写需要在发票备注填写的内容",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.fpbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "fpbz", $$v)
                  },
                  expression: "formData.fpbz",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "font-32 font-weight-500 cor-00 m-t-16 m-b-26" },
            [_vm._v("开票信息")]
          ),
          _vm._l(_vm.formData.kpxxb, function (item, index) {
            return _c(
              "van-cell-group",
              { key: index, staticClass: "b-r-10 m-t-20" },
              [
                _c(
                  "div",
                  {
                    staticClass: "p-b-20",
                    staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                  },
                  [
                    _c(
                      "van-row",
                      {
                        staticClass: "flex col-center",
                        attrs: { type: "flex", align: "center" },
                      },
                      [
                        _c("van-col", { attrs: { span: 15 } }, [
                          _c("img", {
                            staticClass: "w-5 h-28",
                            attrs: {
                              src: `${_vm.image_base_url}/icon_line.png`,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "cor-33 font-weight-500 font-28 m-l-16",
                            },
                            [_vm._v(_vm._s(`开票信息${index + 1}`))]
                          ),
                        ]),
                        _c(
                          "van-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "van-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "primary",
                                  "native-type": "button",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.popupShow(
                                      _vm.kjnr.show,
                                      index,
                                      "itemName"
                                    )
                                  },
                                },
                              },
                              [_vm._v("选择开具内容")]
                            ),
                          ],
                          1
                        ),
                        _vm.isShowIcon("kpxxb")
                          ? _c(
                              "van-col",
                              {
                                staticClass: "m-t-14",
                                attrs: { span: 2 },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "kpxxb")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom" },
                    model: {
                      value: _vm.kjnr.show[index],
                      callback: function ($$v) {
                        _vm.$set(_vm.kjnr.show, index, $$v)
                      },
                      expression: "kjnr.show[index]",
                    },
                  },
                  [
                    _c("van-nav-bar", {
                      attrs: {
                        title: "选择开具内容",
                        "left-text": "取消",
                        "right-text": "确定",
                      },
                      on: {
                        "click-left": function ($event) {
                          return _vm.popupHidden(_vm.kjnr.show, index)
                        },
                        "click-right": function ($event) {
                          return _vm.kjnrSubmit(item, index)
                        },
                      },
                    }),
                    _c("van-search", {
                      attrs: { clearable: "", shape: "round" },
                      on: {
                        input: function ($event) {
                          return _vm.pickerSearch($event, _vm.kjnr)
                        },
                      },
                      model: {
                        value: _vm.kjnr.filterText,
                        callback: function ($$v) {
                          _vm.$set(_vm.kjnr, "filterText", $$v)
                        },
                        expression: "kjnr.filterText",
                      },
                    }),
                    _c("van-picker", {
                      ref: `kjnrPicker_${index}`,
                      refInFor: true,
                      attrs: {
                        "value-key": "name",
                        columns: _vm.kjnr.filteredData,
                      },
                      on: {
                        cancel: function ($event) {
                          _vm.kjnr.show = false
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "itemName",
                      expression: "'itemName'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("itemName"),
                    required: _vm.isRequired("itemName"),
                    rules: _vm.getRules("itemName"),
                    name: "itemName",
                    maxlength: "50",
                    autosize: "",
                    label: "开具内容",
                    placeholder: "请输入开具内容",
                    "input-align": "right",
                  },
                  model: {
                    value: item.itemName,
                    callback: function ($$v) {
                      _vm.$set(item, "itemName", $$v)
                    },
                    expression: "item.itemName",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "specifications",
                      expression: "'specifications'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("specifications"),
                    required: _vm.isRequired("specifications"),
                    rules: _vm.getRules("specifications"),
                    name: "specifications",
                    maxlength: "10",
                    autosize: "",
                    label: "规格型号",
                    placeholder: _vm.isDisabled("num") ? "" : "请输入规格型号",
                    "input-align": "right",
                  },
                  model: {
                    value: item.specifications,
                    callback: function ($$v) {
                      _vm.$set(item, "specifications", $$v)
                    },
                    expression: "item.specifications",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "unit",
                      expression: "'unit'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("unit"),
                    required: _vm.isRequired("unit"),
                    rules: _vm.getRules("unit"),
                    name: "unit",
                    maxlength: "10",
                    autosize: "",
                    label: "单位",
                    placeholder: _vm.isDisabled("unit") ? "" : "请输入单位",
                    "input-align": "right",
                  },
                  model: {
                    value: item.unit,
                    callback: function ($$v) {
                      _vm.$set(item, "unit", $$v)
                    },
                    expression: "item.unit",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "num",
                      expression: "'num'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("num"),
                    type: "number",
                    rules: _vm.getRules("num"),
                    required: _vm.isRequired("num"),
                    name: "num",
                    maxlength: "100",
                    autosize: "",
                    label: "数量",
                    placeholder: _vm.isDisabled("num") ? "" : "请输入数量",
                    "input-align": "right",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.formatToTwoDecimals(item, "num")
                    },
                    blur: function ($event) {
                      return _vm.calculateAmount(item)
                    },
                  },
                  model: {
                    value: item.num,
                    callback: function ($$v) {
                      _vm.$set(item, "num", $$v)
                    },
                    expression: "item.num",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "price",
                      expression: "'price'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("price"),
                    type: "number",
                    rules: _vm.getRules("price"),
                    required: _vm.isRequired("price"),
                    name: "price",
                    autosize: "",
                    label: "含税单价(元)",
                    placeholder: "请输入单价",
                    "input-align": "right",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.formatToTwoDecimals(item, "price")
                    },
                    blur: function ($event) {
                      return _vm.calculateAmount(item)
                    },
                  },
                  model: {
                    value: item.price,
                    callback: function ($$v) {
                      _vm.$set(item, "price", $$v)
                    },
                    expression: "item.price",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "amount",
                      expression: "'amount'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("amount"),
                    type: "number",
                    rules: _vm.getRules("amount"),
                    required: _vm.isRequired("amount"),
                    name: "amount",
                    autosize: "",
                    label: "含税金额(元)",
                    placeholder: "请输入金额",
                    "input-align": "right",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.formatToTwoDecimals(item, "amount")
                    },
                    blur: function ($event) {
                      return _vm.calculateTotalAmount()
                    },
                  },
                  model: {
                    value: item.amount,
                    callback: function ($$v) {
                      _vm.$set(item, "amount", $$v)
                    },
                    expression: "item.amount",
                  },
                }),
              ],
              1
            )
          }),
          _c("van-field", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.formData.totalAmount,
                expression: "formData.totalAmount",
              },
            ],
            attrs: { label: "", "input-align": "right", readonly: "" },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function () {
                  return [
                    _c("div", [
                      _vm.formData.totalAmount && _vm.formData.totalAmount != 0
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.getFormatValue(_vm.formData.totalAmount) +
                                  " 元"
                              ),
                            },
                          })
                        : _c("span", [_vm._v("无")]),
                      _vm.formData.totalAmount && _vm.formData.totalAmount != 0
                        ? _c("span", { staticClass: "p-l-20" }, [
                            _vm._v(" 大写："),
                          ])
                        : _vm._e(),
                      _vm.formData.totalAmount && _vm.formData.totalAmount != 0
                        ? _c("span", { staticClass: "cor-F64646" }, [
                            _vm._v(
                              _vm._s(_vm.getChinese(_vm.formData.totalAmount))
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.formData.totalAmount,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "totalAmount", $$v)
              },
              expression: "formData.totalAmount",
            },
          }),
          !_vm.isDisabled("kpxxb")
            ? _c(
                "van-row",
                [
                  _c("van-col", { attrs: { span: 12 } }),
                  _c(
                    "van-col",
                    { attrs: { span: 12 } },
                    [
                      _c("van-button", {
                        staticClass: "width-100",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "添加开票信息",
                        },
                        on: { click: _vm.addKpItem },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "font-32 font-weight-500 cor-00 m-t-16 m-b-26" },
            [_vm._v("客户发票信息")]
          ),
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ttlx",
                    expression: "'ttlx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ttlx",
                  required: _vm.isRequired("ttlx"),
                  rules: _vm.getRules("ttlx"),
                  value: _vm.formData.ttlx,
                  label: "抬头类型",
                  placeholder: "请选择抬头类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ttlx,
                            placeholder: "请选择抬头类型",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ttlx, "ttlx")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ttlx.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ttlx, "show", $$v)
                              },
                              expression: "ttlx.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择抬头类型",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ttlx.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ttlx")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.ttlx)
                                },
                              },
                              model: {
                                value: _vm.ttlx.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ttlx, "filterText", $$v)
                                },
                                expression: "ttlx.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ttlx",
                              attrs: { columns: _vm.ttlx.filteredData },
                              on: {
                                cancel: function ($event) {
                                  _vm.ttlx.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "kptt",
                    expression: "'kptt'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("kptt"),
                  required: _vm.isRequired("kptt"),
                  rules: _vm.getRules("kptt"),
                  name: "kptt",
                  maxlength: "100",
                  autosize: "",
                  label: "开票抬头",
                  placeholder: "请输入开票抬头",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.kptt,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "kptt", $$v)
                  },
                  expression: "formData.kptt",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "nsrsbh",
                    expression: "'nsrsbh'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("nsrsbh"),
                  required: _vm.isRequired("nsrsbh"),
                  rules: _vm.getRules("nsrsbh"),
                  name: "nsrsbh",
                  maxlength: "100",
                  autosize: "",
                  label: "纳税人识别号",
                  placeholder: "请输入纳税人识别号",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.nsrsbh,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "nsrsbh", $$v)
                  },
                  expression: "formData.nsrsbh",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "khh",
                    expression: "'khh'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("khh"),
                  rules: _vm.getRules("khh"),
                  required: _vm.isRequired("khh"),
                  name: "khh",
                  maxlength: "100",
                  autosize: "",
                  label: "开户行",
                  placeholder: "请输入开户行",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.khh,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "khh", $$v)
                  },
                  expression: "formData.khh",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "khzh",
                    expression: "'khzh'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("khzh"),
                  rules: _vm.getRules("khzh"),
                  required: _vm.isRequired("khzh"),
                  name: "khzh",
                  maxlength: "100",
                  autosize: "",
                  label: "开户账号",
                  placeholder: "请输入开户账号",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.khzh,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "khzh", $$v)
                  },
                  expression: "formData.khzh",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fpjffs",
                    expression: "'fpjffs'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "fpjffs",
                  required: _vm.isRequired("fpjffs"),
                  rules: _vm.getRules("fpjffs"),
                  value: _vm.formData.fpjffs,
                  label: "发票交付方式",
                  placeholder: "请选择发票交付方式",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.fpjffs,
                            placeholder: "请选择发票交付方式",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.fpjffs, "fpjffs")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.fpjffs.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.fpjffs, "show", $$v)
                              },
                              expression: "fpjffs.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择发票交付方式",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.fpjffs.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("fpjffs")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.fpjffs)
                                },
                              },
                              model: {
                                value: _vm.fpjffs.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.fpjffs, "filterText", $$v)
                                },
                                expression: "fpjffs.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "fpjffs",
                              attrs: { columns: _vm.fpjffs.filteredData },
                              on: {
                                cancel: function ($event) {
                                  _vm.fpjffs.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "kpdz",
                    expression: "'kpdz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("kpdz"),
                  required: _vm.isRequired("kpdz"),
                  rules: _vm.getRules("kpdz"),
                  name: "kpdz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "开票地址",
                  "show-word-limit": "",
                  placeholder: "请输入开票地址",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.kpdz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "kpdz", $$v)
                  },
                  expression: "formData.kpdz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "dh",
                    expression: "'dh'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("dh"),
                  type: "number",
                  name: "dh",
                  rules: _vm.getRules("dh"),
                  required: _vm.isRequired("dh"),
                  maxlength: 20,
                  placeholder: "请输入电话",
                  label: "电话",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.dh,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "dh", $$v)
                  },
                  expression: "formData.dh",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.formData.fpjffs == "邮寄"
            ? _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-16 m-b-26" },
                [_vm._v("邮寄信息")]
              )
            : _vm._e(),
          _vm.formData.fpjffs == "邮寄"
            ? _c(
                "van-cell-group",
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "lxr",
                        expression: "'lxr'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("lxr"),
                      required: !_vm.isDisabled("lxr"),
                      rules: [
                        {
                          required: !_vm.isDisabled("lxr"),
                          message: "请输入联系人",
                        },
                      ],
                      name: "lxr",
                      maxlength: "20",
                      label: "联系人",
                      placeholder: "请输入联系人",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.lxr,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "lxr", $$v)
                      },
                      expression: "formData.lxr",
                    },
                  }),
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "lxfs",
                        expression: "'lxfs'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("lxfs"),
                      type: "number",
                      name: "lxfs",
                      rules: [
                        {
                          required: !_vm.isDisabled("lxfs"),
                          message: "请输入联系方式",
                        },
                      ],
                      required: !_vm.isDisabled("lxfs"),
                      maxlength: 20,
                      placeholder: "请输入联系方式",
                      label: "联系方式",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.lxfs,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "lxfs", $$v)
                      },
                      expression: "formData.lxfs",
                    },
                  }),
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "yjdz",
                        expression: "'yjdz'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("yjdz"),
                      required: !_vm.isDisabled("yjdz"),
                      rules: [
                        {
                          required: !_vm.isDisabled("yjdz"),
                          message: "请输入邮寄地址",
                        },
                      ],
                      name: "yjdz",
                      type: "textarea",
                      maxlength: "200",
                      rows: "3",
                      autosize: "",
                      label: "邮寄地址",
                      "show-word-limit": "",
                      placeholder: "请输入邮寄地址",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.yjdz,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "yjdz", $$v)
                      },
                      expression: "formData.yjdz",
                    },
                  }),
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "xxdz",
                        expression: "'xxdz'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("xxdz"),
                      required: !_vm.isDisabled("xxdz"),
                      rules: [
                        {
                          required: !_vm.isDisabled("xxdz"),
                          message: "请输入详细地址",
                        },
                      ],
                      name: "xxdz",
                      type: "textarea",
                      maxlength: "200",
                      rows: "3",
                      autosize: "",
                      label: "详细地址",
                      "show-word-limit": "",
                      placeholder: "请输入详细地址",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.xxdz,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "xxdz", $$v)
                      },
                      expression: "formData.xxdz",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-35", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("contract", {
        attrs: { show: _vm.htmc.show },
        on: {
          finish: _vm.contractFinish,
          close: function ($event) {
            _vm.htmc.show = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }